import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

export const canUseSearchAsHomePage: Permission = () =>
  getFlag(FlagType.SearchAsHomePage);
